import React, { createContext, useState, useEffect } from 'react';
import io from 'socket.io-client';
let hostname = process.env.REACT_APP_API_URL || "" //process.env.REACT_APP_API_URL

const SocketContext = createContext(null);

export function SocketProvider({ children }) {
  const [socket, setSocket] = useState(null);

  useEffect(() => {
    if (hostname == "") hostname = window.location.origin
    const s = io(hostname);
    setSocket(s);
  }, []);

  return (
    <SocketContext.Provider value={{ socket }}>
      {children}
    </SocketContext.Provider>
  );
}

export default SocketContext;